export default __webpack_public_path__ + "static/media/pdf.52ac6845.svg";